import React, { useRef, lazy } from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';
import { ArrowUpRightIcon } from 'lucide-react';
interface ProjectCardProps {
  title: string;
  description: string;
  categories: string[];
  imageUrl: string;
  url: string;
  index: number;
}
export function ProjectCard({
  title,
  description,
  categories,
  imageUrl,
  url,
  index
}: ProjectCardProps) {
  const cardRef = useRef<HTMLDivElement>(null);
  const {
    scrollYProgress
  } = useScroll({
    target: cardRef,
    offset: ['start end', 'end start']
  });
  const imageY = useTransform(scrollYProgress, [0, 1], ['-4%', '4%']);
  return <motion.div ref={cardRef} initial={{
    opacity: 0,
    y: 40
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-5%'
  }} transition={{
    duration: 0.8,
    delay: index % 2 === 0 ? 0 : 0.1,
    ease: [0.16, 1, 0.3, 1]
  }} data-id="element-316">
      <a href={url} target="_blank" rel="noopener noreferrer" className="group block cursor-pointer" data-id="element-317">
        {/* Browser mockup frame */}
        <div className="relative overflow-hidden rounded-lg mb-5 bg-surface border border-border/50" data-id="element-318">
          <div className="flex items-center gap-1.5 px-4 py-2.5 bg-surface border-b border-border/50" data-id="element-319">
            <div className="w-2 h-2 rounded-full bg-white/10" data-id="element-320" />
            <div className="w-2 h-2 rounded-full bg-white/10" data-id="element-321" />
            <div className="w-2 h-2 rounded-full bg-white/10" data-id="element-322" />
            <div className="ml-3 flex-1 h-4 rounded bg-white/5 max-w-[180px]" data-id="element-323" />
          </div>
          <div className="relative aspect-[16/9] overflow-hidden" data-id="element-324">
            <motion.img src={imageUrl} alt={title} className="absolute inset-0 w-full h-full object-cover object-top transition-transform duration-700 ease-out group-hover:scale-[1.03]" style={{
            y: imageY
          }} loading="lazy" data-id="element-325" />
            <div className="absolute inset-0 bg-background/0 group-hover:bg-background/10 transition-colors duration-500" data-id="element-326" />
            <div className="absolute top-4 right-4 w-9 h-9 rounded-full backdrop-blur-sm border border-white/0 flex items-center justify-center opacity-0 group-hover:opacity-100 group-hover:bg-white/10 group-hover:border-white/20 transition-all duration-500 translate-y-2 group-hover:translate-y-0" data-id="element-327">
              <ArrowUpRightIcon className="w-3.5 h-3.5 text-primary" data-id="element-328" />
            </div>
          </div>
        </div>

        {/* Text */}
        <div data-id="element-329">
          <div className="flex items-center gap-3 mb-2" data-id="element-330">
            <h3 className="text-xl md:text-2xl font-display font-bold text-primary tracking-tight" data-id="element-331">
              {title}
            </h3>
            <span className="text-[11px] text-secondary/50 tracking-wider uppercase font-light shrink-0" data-id="element-332">
              {categories[0]}
            </span>
          </div>
          <p className="text-secondary/80 text-sm md:text-base leading-relaxed font-light" data-id="element-333">
            {description}
          </p>
        </div>
      </a>
    </motion.div>;
}